import Validators from '../validators'

export default (store) => store.createEmbededEntityState({
  attrs: ['name', 'country', 'value'],
  titles: [store.__('name'), store.__('regions'), store.__('value')],
  _sortField: 'name',
  attributesFilter: { key: 'platform', value: 'flix' },
  initVals: (row) => ({ platform: 'flix' }),
  validators: {
    name: Validators.isMandatory(store),
    value: Validators.isMandatory(store),
    country: Validators.isMandatory(store),
    regions: Validators.regionTest(store),
    '_global': (vals, items) => {
      // const val = vals.get('country')
      // const idVals = store.options.get('VideoId').map((i) => i.value)
      // const same = items.filter((i) => {
      //   const rightName = idVals.indexOf(i.name) >= 0
      //   return rightName && i.country && i.country.indexOf(val) >= 0 || val.indexOf(i.country) >= 0
      // })
      // if (same.length > 0) {
      //   return store.__('region already present')
      // }
    }
  }
})
